import { render, staticRenderFns } from "./fruitTree.vue?vue&type=template&id=04503910&scoped=true"
import script from "./fruitTree.vue?vue&type=script&lang=ts"
export * from "./fruitTree.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04503910",
  null
  
)

export default component.exports